;
define("product_list_details.tpl", function(){});

